export enum MobileInnerErrorOptions {
  MobileView = 'mobile-view',
  LandscapeMode = 'landscape-mode',
  TabletView = 'tablet-view'
}
